import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Creators as procedureActions } from '../../../../../../../domain/useCases/procedures/getProcedureInformation';
import constants from '../../../../constants';
import BSEview from './BSEview';
import routes from '../../../../../../components/Routes/routingMap';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';

const BSEviewController = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { procedure: valueProcedure, isLoading: isLoadingProcedure } =
    useSelector((state: any) => state.procedureInformation);
  const { procedure: procedureSelectedInfo } = useSelector(
    (state: any) => state.procedureInformation
  );

  const handleRequestProcedure = (
    setShowModalNotAvailable: any,
    setShowModalExistRequest: any,
    setShowModalNotAllowed: any
  ) => {
    if (
      procedureSelectedInfo?.currentRequestId &&
      procedureSelectedInfo?.currentRequestId !== 0
    ) {
      setShowModalExistRequest(true);
      return;
    }
    if (procedureSelectedInfo?.disabled) {
      setShowModalNotAvailable(true);
      return;
    }
    if (procedureSelectedInfo?.error) {
      setShowModalNotAllowed(true);
      return;
    }
    history.push(
      routes.student.procedures.categories.scholarships.bse.register
    );
  };

  const handlerRedirectNewPage = (url: any, e?: any) => {
    const testId = e?.currentTarget.dataset.testid;
    if (testId === 'cmp-list-documents-button') {
      GoogleAnalytics.writeLog(
        'portal-procedure-clickSeeListDocuments',
        'procedure'
      );
    }
    window.open(url, '_blank');
  };

  useEffect(() => {
    GoogleAnalytics.writeLog('portal-procedure-bse', 'procedure');
    if (!valueProcedure && !isLoadingProcedure)
      dispatch(
        procedureActions.getProcedureInformation(
          constants.categories.requests.procedures.bse
        )
      );
  }, []);

  return (
    <BSEview
      propProcedure={valueProcedure}
      handleRequestProcedure={handleRequestProcedure}
      handlerRedirectNewPage={handlerRedirectNewPage}
      error={procedureSelectedInfo?.error}
    />
  );
};
export default BSEviewController;
